import { render, staticRenderFns } from "./LandingPageDetails.vue?vue&type=template&id=56ff14d9&scoped=true"
import script from "./LandingPageDetails.vue?vue&type=script&lang=js"
export * from "./LandingPageDetails.vue?vue&type=script&lang=js"
import style0 from "./LandingPageDetails.vue?vue&type=style&index=0&id=56ff14d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ff14d9",
  null
  
)

export default component.exports